/*
 ================================================
 COLOR CONSTANTS
 ================================================
 */

export const PLATFORM_BASE_COLOR = '#3a4044', PLATFORM_CONTRAST_COLOR = 'white';